import {
  Alert,
  Button,
  Group,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { IconBrandTiktok } from "@tabler/icons-react";
import { Link } from "react-router-dom";

interface TiktokConnectBannerProps {
  onDismiss: () => void;
}

function TiktokConnectBanner({ onDismiss }: TiktokConnectBannerProps) {
  const theme = useMantineTheme();

  return (
    <Alert color="pink" radius={0} py={"xs"} mt={{ base: "sm", sm: 0 }}>
      <Stack gap="sm" hiddenFrom="sm">
        <Group align="flex-start" wrap="nowrap">
          <IconBrandTiktok
            color={theme.colors.pink[6]}
            size="1.2rem"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <Text fw={700} c={"pink"} size="sm">
            Connect your TikTok to automatically share your stats with brands!
          </Text>
        </Group>
        <Group gap="xs">
          <Button
            component={Link}
            to="/signup/complete"
            variant="light"
            color="pink"
            size="sm"
            style={{ flex: 1 }}
          >
            Continue Setup
          </Button>
          <Button
            variant="subtle"
            color="gray"
            size="sm"
            onClick={onDismiss}
            style={{ flex: 1 }}
          >
            Don't Show Again
          </Button>
        </Group>
      </Stack>

      <Group justify="space-between" visibleFrom="sm">
        <Group align="flex-start" wrap="nowrap">
          <IconBrandTiktok
            color={theme.colors.pink[6]}
            size="1.2rem"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <Text fw={700} c={"pink"} size="sm">
            Connect your TikTok to automatically share your stats with brands!
          </Text>
        </Group>
        <Group gap="xs" style={{ flexShrink: 0 }}>
          <Button
            component={Link}
            to="/signup/complete"
            variant="light"
            color="pink"
            size="sm"
          >
            Continue Setup
          </Button>
          <Button variant="subtle" color="gray" size="sm" onClick={onDismiss}>
            Don't Show Again
          </Button>
        </Group>
      </Group>
    </Alert>
  );
}

export default TiktokConnectBanner;
